@import './media.css';

.root {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100lvh;
}

.header {
  position: sticky;
  z-index: 30;
  top: 0;
  background: hsl(var(--background));
}

.playerControls {
  position: sticky;
  z-index: 50;
  bottom: 0;
  margin-inline: auto;

  @media (width >= v-sm) {
    padding-inline: 1rem;
  }
}

.queue {
  isolation: isolate;
  position: fixed;
  z-index: 40;
  inset: 0 0 var(--player-toolbar-height);
  background: hsl(var(--background));
}
